exports.APP_LABEL = 'images';
exports.RESULTS_PER_PAGE_INITIAL_DESKTOP = 24;
exports.RESULTS_PER_PAGE_INITIAL_MOBILE = 8;
exports.RESULTS_PER_PAGE_DESKTOP = 60;
exports.RESULTS_PER_PAGE_MOBILE = 24;
exports.PROXY_IMAGE_SIZE = 390;
